<template>
    <v-container grid-list-lg>

        <v-layout row wrap class="meal-plans">
            <v-loading class="loading" v-model="loading" v-if="loading">
    
                <!-- <v-progress-circular persistent
                :size="70"
                :width="7"
                color="primary"
                indeterminate
                ></v-progress-circular> -->
                <!-- <img src="https://sergipetec.com.br/wp-content/uploads/2018/11/animacao1.gif" /> -->
                <!-- <img class="img1" src="https://lacrion.com/wp-content/themes/Lacrion/images/loader.gif" /> -->
                <img class="img2" src="https://media.giphy.com/media/uhUm65Uz2Ckne/giphy.gif" />
                <!-- <img src="https://icon-library.net/images/icon-gif/icon-gif-24.jpg" /> -->
                
        
            </v-loading>
            <v-loading class="loadingPadrao" v-model="loadingPadrao" v-if="loadingPadrao">
                <v-progress-circular persistent :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
            </v-loading>
            <v-alert  role="alert" class="v-alert v-sheet theme--dark v-alert--material warning alertaEvento" to="/eventos-listagem" v-if="alertaEvento"
                :value="true"
                color="warning"
                icon="priority_high"
                outline
                >
                <div class="v-alert__wrapper">
                    <div @click="goToEvento" class="v-alert__content">
                        {{msgEventoAlerta}}
                    </div>
                    <a class="fecharAviso" v-if="alertaEvento" @click="alertaEvento = false"><img :src="icFecharLaranja" /></a>
                    
                </div>
                
            </v-alert>
            
            <!-- <h1 style="position:fixed; top:50px; z-index: 9999999999999">{{debug1}}</h1> -->
            <!-- <h1 style="position:fixed; top:110px; z-index: 9999999999999">{{debug2}}</h1> -->
            <v-flex v-for="(item, index) in todosItems" xs12 sm6 md4 row style="margin-bottom:5px; padding:0">
                <v-card class="box">
                    <h3 class="titulo-post" :title="item.nome"><b>Publicado por:</b> {{item.nome}}</h3> <!-- {{ parentMessage }} - {{ index }} - {{ item.message }} -->
                    <img v-if="item.imagemPost != null && item.tipo != 2" :src="item.imagemPost" class="imagem" />
                    <iframe style="width:100%; height:auto" width="560" height="315" v-if="item.tipo == 2" :src="item.video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    <v-card-text>
                        <v-btn v-if="slugUsuarioLogado == item.slugAutor" class="deletar" flat color="orange" flat="flat" @click="deletarItem(item.slug)"><img :src="lixeira" class="lixeira" /></v-btn>
                            <!--div class="imagem"  style="background-image: url('http://www.closebecoming.co.uk/images/category_10/Honey%20%20B%20Women%20Black%20Self%20Design%20Top%20Beautiful%20BLOVOT.jpg');" ></div-->
                            
                            <div class="body-content">
                                <i>{{item.dia}}/{{item.mes}}/{{item.ano}} - {{item.hora}}:{{item.minuto}}</i>
                                <div>{{item.texto}}</div> <!-- {{ parentMessage }} - {{ index }} - {{ item.message }} -->
                                <a v-if="item.textoLink != ''" target="blank" :href="item.link">{{item.textoLink}}</a><br />
                            </div>

                        <v-card-actions class="users">
                            <v-btn class="comentar" flat color="orange" flat="flat" @click="comentarios(item.slug)">Comentários({{item.quantidadeComentarios}})</v-btn>
                            <v-btn v-if="slugUsuarioLogado == item.slugAutor" class="editar" flat color="orange" flat="flat" @click="editarItem(item.slug)">Editar</v-btn>
                            <a :class="'like' + ' ' + item.statusCurtida" :data-curtido="item.statusCurtida" :data-slug="item.slug"><img :src="imgLike1" class="curtir" /><img :src="imgLike2" class="curtido" /> (<span>{{item.quantidadeCurtidas}}</span>)</a>
                        </v-card-actions>
                        
                    </v-card-text>
                
                </v-card>
            </v-flex>             

        </v-layout>
        <v-dialog v-model="dialogComunicado" persistent modal-comunicado max-width="90%">
            <v-card>
                
                <v-flex v-for="(item, index) in itemsComunicados" xs12 sm6 md4 row style="margin-bottom:5px; padding:0">
                    <v-card-title class="headline">Comunicado!</v-card-title>
                    <img :src="item.imgComunicado" class="img-modal-comunicado" />
                    <v-card-text>{{item.texto}}</v-card-text>
                    
                </v-flex>
                
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="fecharComunicado()">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-if="exibirEnqueteUmaVez" v-model="dialogEnquete" modal-comunicado max-width="90%">
            <v-card>
                <a class="fecharX" @click="fecharEnquete()">x</a>
                <v-flex v-for="(item, index) in itemsEnquetes" xs12 sm6 md4 row style="margin-bottom:5px; padding:0">
                    <v-card-title class="headline">Enquete!</v-card-title>
                    <v-card-text>
                        <b>{{item.pergunta}}</b>

                        <!-- <p>Valor selecionado: {{ radios }}</p> -->
                        <div v-for="(item2, index) in item.respostas">
                            <v-radio-group v-model="radios" :mandatory="false">
                                <v-radio :label="item2" :value="item2"></v-radio>
                            </v-radio-group>
                        </div>
                        <!-- <v-card-text>{{item.respostas}}</v-card-text> -->
                    </v-card-text>
                </v-flex>
                
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <!-- <v-btn color="green darken-1" style="position:absolute; color:#ff9800!important"  flat @click="fecharEnquete()">Fechar</v-btn> -->
                <v-btn color="green darken-1" style="border:solid 1px green;" flat @click="votarEnquete()">Votar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-if="exibirEventoUmaVez" v-model="exibirDialogEvento" persistent modal-evento max-width="90%">
            <v-card>
                
                <v-flex v-for="(item, index) in itemsEventos" xs12 sm6 md4 row style="margin-bottom:5px; padding:0">
                    <v-card-title class="headline">Evento!</v-card-title>
                    <img :src="item.imgEvento" class="img-modal-evento" />
                    <v-card-text><b>{{item.titulo}}</b><br />{{item.descricao}}</v-card-text>
                    
                </v-flex>
                
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="fecharEvento()">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDeleteConfirm" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Deseja realmente deletar esse post permanentemente?</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click="dialogDeleteConfirm = false">Não</v-btn>
                <v-btn color="green darken-1" flat @click="deletarItemConfirm">Sim</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDeletarComentarioConfirmacao" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Deseja realmente deletar esse comentário permanentemente?</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click="dialogDeletarComentarioConfirmacao = false">Não</v-btn>
                <v-btn color="green darken-1" flat @click="deletarComentarioConfirmacao">Sim</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAniversario" persistent max-width="290">
            <v-card>
                <v-card-title class="headline"><img src="https://yeshuaartsgraficas.com.br/resources/banner-de-aniversario-o-aniversario-chegou.jpg" style="width:100%; height:auto" /></v-card-title>
                
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click="fecharModalAniversario">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogComentarios" class="comentarios-modal" min-width="99%" max-width="99%">
            <v-card>
                <a class="fecharComentario" @click="dialogComentarios = false">x</a>
                <v-card-title class="headline">Comentários</v-card-title>
                <v-flex v-for="(item, index) in itemsComentarios" xs12 sm6 md4 row style="margin:10px 6px; padding:3px; background: #f5f5f5; border-radius:10px">
                    <v-card-text>
                        <a v-if="item.slugAutor == slugUsuarioLogado || perfilUsuarioLogado == 1" @click="deletarComentario(item.slug)" class="deletarComentario"><img :src="lixeira" class="lixeira" /></a>
                        <span>{{item.textoComentario}}</span><br />
                        <b>Comentado por: </b> <span>{{item.criadoPor}}</span> às <span>{{item.dataFormatada}}</span>

                    </v-card-text>
                    
                </v-flex>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-text-field name="textoComentario" label="Digite o comentário" type="text"
                                v-model="textoComentario" data-cy="joinEmailField" required>
                </v-text-field>
                <v-btn color="green darken-1" flat @click="adicionarComentario('ab68d08f-a478-4d10-9386-dd8e17fddc1b')">Comentar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>    
       
    </v-container>
    
</template>

<script src="../google-analytics-events.js" async defer></script>
<script>

import img1 from '../assets/img1.jpg';
import img2 from '../assets/img2.jpg';
import img3 from '../assets/img3.jpg';
import imgLike1 from '../assets/imgLike1.png';
import imgLike2 from '../assets/imgLike2.png';

import lixeira from '../assets/ic-lixeira.png';

import icFecharLaranja from '../assets/icFecharLaranja.jpg';

import { fb } from '../firebase/index';
import db from './firebaseInit';
import firebase from 'firebase';

import { userProperties, globalProperties, usersData, cache } from '@/global.js'

import Vue from 'vue'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

var carregaDadosUmaVez = false;

export default {
    name: 'HomePlans',
    methods: {
        showRecipes(plan) {
            this.$store.dispatch('getRecipes', plan);
        },
        setUSerproperties(){
            this.exibirEventoUmaVez = true;
            var that = this;
            if(userProperties.loaded == false){
                var user = firebase.auth().currentUser;
            
                var name, email, photoUrl, uid, emailVerified;
                if (user != null) {
                    
                    //name = user.displayName;
                    email = user.email;
                    
                    // Salva os dados na sessionStorage
                    sessionStorage.setItem('email', email);
                    //this.origem = email
                    //alert(email);
                    // perfilamento
                    //photoUrl = user.photoURL;
                    //emailVerified = user.emailVerified;
                    //uid = user.uid;  // The user's ID, unique to the Firebase project. Do NOT use
                                    // this value to authenticate with your backend server, if
                                    // you have one. Use User.getToken() instead.
                    
                    db.collection("usuarios")
                    .where("email", "==", email)
                    .get()
                    .then((querySnapshot) => {
                        console.log(querySnapshot);
                        //var quantidadeItens = querySnapshot.size
                        querySnapshot.forEach(doc => {
                            console.log(doc);

                            // Para popular dados do usuario apenas uma vez
                            userProperties.loaded = true;
                            // doc.data() is never undefined for query doc snapshots
                            console.log(doc.id, " => ", doc.data());               
                            let customObj = doc.data()
                            
                            userProperties.email = customObj.email;
                            userProperties.imagem = customObj.slug + "." + customObj.extensao;
                            userProperties.perfil = customObj.perfil,
                            userProperties.slug = customObj.slug,
                            userProperties.extensao = customObj.extensao,
                            userProperties.nome = customObj.nome,
                            userProperties.tokenFMC = customObj.tokenFMC,
                            userProperties.celular = customObj.celular,
                            userProperties.dataNascimento = customObj.dataNascimento,
                            userProperties.dataVencimentoMensal = customObj.dataVencimentoMensal,
                            userProperties.turmas = customObj.turmas,
                            userProperties.alunos = customObj.alunos,

                            this.nome = customObj.nome,
                            userProperties.escolaID = customObj.escolaID,
                            this.escolaID = customObj.escolaID;
                            this.slugUsuarioLogado = customObj.slug;
                            this.perfilUsuarioLogado = customObj.perfil;
                            
                        });
                        this.getUsersData();
                        this.carregaDados();
                        carregaDadosUmaVez = true;
                        //this.carregaDados();
                    })
                    .catch(function (error) {
                        console.log("Erro ao consultar banco para atualizar as propriedades do usuário.");
                        setTimeout(function(){ that.carregaDados(); }, 3000);
                    });
                    
                }
                
            }

            // Log do sistema
            if(userProperties.escolaID != null){            
                // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second

                db.collection('log_' + userProperties.escolaID).add({
                        escolaID: userProperties.escolaID,
                        slugAutor: userProperties.slug,
                        perfil: userProperties.perfil,
                        
                        //slug: this.slug,
                        customtimestamp: customtimestamp,
                        dia: day,
                        mes: month,
                        ano: year,
                        acao: "acessar",
                        categoria: "login",
                        pontos: 1
                        
                    })
                    .then(docRef => {
                        console.log('Document written with ID: ', docRef.id);

                        
                    })
                    .catch(function (error) {
                        console.log('Error adding document: ', error);
                        console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                    })
            }
            else{
                this.$router.push(`/`);
            }
            
            
        },
        comentarios(slug){
            this.loadingPadrao = true;
            // Google Analytics - Events
            gtag('event', 'clicou', {
                'event_category': 'homepage',
                'event_label': 'comentarios'//,
                //'value': '<value>'
            });

            this.textoComentario = null;
            this.dialogComentarios = true;
            this.slugPost = slug;
            this.itemsComentarios = []
            
            // ordernar exibicao - numerica
            function ordenarPorTimestamp(a, b){
                return a.timestamp - b.timestamp; // crescente
                //return b.timestamp - a.timestamp; // decrescente
            }

            db.collection("posts_" + userProperties.escolaID).where("slug", "==", slug)
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach(doc => {
                        console.log(doc.id, " => ", doc.data());
                        // Build doc ref from doc.id
                        db.collection("posts_" + userProperties.escolaID).doc(doc.id).collection("comentarios")
                        .get()
                        .then((querySnapshot) => {
                            var quantidadeItens = querySnapshot.size;
                            if(quantidadeItens != 0){
                                querySnapshot.forEach(doc => {
                                    console.log(doc.id, " => ", doc.data());
                                    // Build doc ref from doc.id
                        
                                    let customObj = doc.data()
                                    //console.log(customObj);

                                    this.itemsComentarios.push({"slug": customObj.slug, "slugAutor": customObj.slugAutor, "criadoPor": customObj.criadoPor, "textoComentario": customObj.textoComentario, "timestamp": customObj.timestamp, "dataFormatada": customObj.timestamp.substring(6,8) + "/" + customObj.timestamp.substring(4,6) + "/" + customObj.timestamp.substring(0,4) + " - " + customObj.timestamp.substring(8,10) + ":" + customObj.timestamp.substring(10,12)});
                                });

                                this.itemsComentarios.sort(ordenarPorTimestamp);
                                this.loadingPadrao = false;
                            }
                            if(quantidadeItens == 0){
                                alert("Ainda não possui nenhum comentário. Seja o primeiro!");
                                this.loadingPadrao = false
                                //this.dialogComentarios = false;
                            }  
                        })
                    });
                })
        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        },
        adicionarComentario(slug){

            // Google Analytics - Events
            gtag('event', 'clicou', {
                'event_category': 'homepage',
                'event_label': 'adicionar comentario'//,
                //'value': '<value>'
            });

            var that = this;

            var now = new Date();
            var year = "" + now.getFullYear();
            var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
            var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
            var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
            var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
            var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
            //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
            var customtimestamp = year + month + day + hour + minute + second;

            var slugComentario = this.generateUUID();

            // Log do sistema
            if(userProperties.escolaID != null){            
                // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second

                db.collection('log_' + userProperties.escolaID).add({
                        escolaID: userProperties.escolaID,
                        slugAutor: userProperties.slug,
                        perfil: userProperties.perfil,
                        
                        //slug: this.slug,
                        customtimestamp: customtimestamp,
                        dia: day,
                        mes: month,
                        ano: year,
                        acao: "comentar",
                        categoria: "postagens",
                        pontos: 4
                        
                    })
                    .then(docRef => {
                        console.log('Document written with ID: ', docRef.id);

                        
                    })
                    .catch(function (error) {
                        console.log('Error adding document: ', error);
                        console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                    })
            }
            else{
                alert("1 - Sua sessão expirou, você será redirecionado para reautenticar!");
                this.$router.push(`/`);
            }

            db.collection("posts_" + userProperties.escolaID).where("slug", "==", this.slugPost)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach(doc => {
                    console.log(doc.id, " => ", doc.data());
                    // Build doc ref from doc.id
                    db.collection("posts_" + userProperties.escolaID).doc(doc.id).collection('comentarios').add({
                        "slug":slugComentario, 
                        "textoComentario":that.textoComentario, 
                        "timestamp":customtimestamp, 
                        "criadoPor":userProperties.nome, 
                        "slugAutor":userProperties.slug
                        //texto: "testeabc" 
                        
                    }).then(docRef => {
                        //this.$router.push(`/${slug}/success`)
                        this.dialogComentarios = false;
                        this.comentarios(this.slugPost);
                        cache.home = false;
                        carregaDadosUmaVez = false;
                        
                        
                    })
                    .catch(function (error) {
                        that.loading = false
                        console.log('Error adding document: ', error);
                        alert("Erro ao adicionar comentário. Tente novamente mais tarde!")
                    })
                    this.loading = false,
                    this.dialog = true

                });
            })
        },
        fnAlertaEvento(){
            // timestamp
            var now = new Date();
            var year = "" + now.getFullYear();
            var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
            var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
            //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
            var currentDate = year + month + day;

            // converter para o objeto de data e subtrair dias
            var eventoAnoStart = null;
            var eventoMesStart = null;
            var eventoDiaStart = null;

            var eventoAnoFormatadoStart = null;
            var eventoMesFormatadoStart = null;
            var eventoDiaFormatadoStart = null;
            var eventoDataFormatadaStart = null;

            // var eventoAnoEnd = null;
            // var eventoMesEnd = null;
            // var eventoDiaEnd = null;

            // var eventoAnoFormatadoEnd = null;
            // var eventoMesFormatadoEnd = null;
            // var eventoDiaFormatadoEnd = null;
            // var eventoDataFormatadaEnd = null;

            //Verifica como e quando deve exibir o comunicado
            db.collection("eventos")//.orderBy("customtimestamp","desc")
            .where("escolaID", "==", userProperties.escolaID)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach(doc => {
                    // doc.data() is never undefined for query doc snapshots
                    //console.log(doc.id, " => ", doc.data());
                    
                    
                    let customObj = doc.data()

                    // converter para o objeto de data e subtrair dias(Pega data de inicio do evento - 7 dias)
                    eventoAnoStart = Number(customObj.dateStart.substring(0,4));

                    eventoMesStart = customObj.dateStart.replace(/-/g, '').substring(4,6);
                    if(eventoMesStart.substring(0,1) == 0){
                        eventoMesStart = eventoMesStart.substring(1,2);
                    }
                    eventoMesStart = Number(eventoMesStart);

                    eventoDiaStart = customObj.dateStart.replace(/-/g, '').substring(6,8);
                    if(eventoDiaStart.substring(0,1) == 0){
                        eventoDiaStart = eventoDiaStart.substring(1,2);
                    }
                    eventoDiaStart = Number(eventoDiaStart);
                    
                    
                    var eventStartDate = new Date(eventoAnoStart, eventoMesStart, eventoDiaStart);
                    eventStartDate.setDate( eventStartDate.getDate() - 7 );

                    eventoAnoFormatadoStart = "" + eventStartDate.getFullYear();
                    eventoMesFormatadoStart = "" + (eventStartDate.getMonth()); if (eventoMesFormatadoStart.length == 1) { eventoMesFormatadoStart = "0" + eventoMesFormatadoStart; }
                    eventoDiaFormatadoStart = "" + eventStartDate.getDate(); if (eventoDiaFormatadoStart.length == 1) { eventoDiaFormatadoStart = "0" + eventoDiaFormatadoStart; }

                    eventoDataFormatadaStart = Number(eventoAnoFormatadoStart + eventoMesFormatadoStart + eventoDiaFormatadoStart);

                    // converter para o objeto de data e subtrair dias(Pega data de inicio do evento - 7 dias)
                    // eventoAnoEnd = Number(customObj.dateEnd.substring(0,4));

                    // eventoMesEnd = customObj.dateEnd.replace(/-/g, '').substring(4,6);
                    // if(eventoMesEnd.substring(0,1) == 0){
                    //     eventoMesEnd = eventoMesEnd.substring(1,2);
                    // }
                    // eventoMesEnd = Number(eventoMesEnd);

                    // eventoDiaEnd = customObj.dateEnd.replace(/-/g, '').substring(6,8);
                    // if(eventoDiaEnd.substring(0,1) == 0){
                    //     eventoDiaEnd = eventoDiaEnd.substring(1,2);
                    // }
                    // eventoDiaEnd = Number(eventoDiaEnd);
                    
                    
                    // var eventEndDate = new Date(eventoAnoEnd, eventoMesEnd, eventoDiaEnd);
                    // eventEndDate.setDate( eventEndDate.getDate() - 7 );
                    // alert(eventEndDate);

                    // eventoAnoFormatadoEnd = "" + eventEndDate.getFullYear();
                    // eventoMesFormatadoEnd = "" + (eventEndDate.getMonth() + 1); if (eventoMesFormatadoEnd.length == 1) { eventoMesFormatadoEnd = "0" + eventoMesFormatadoEnd; }
                    // eventoDiaFormatadoEnd = "" + eventEndDate.getDate(); if (eventoDiaFormatadoEnd.length == 1) { eventoDiaFormatadoEnd = "0" + eventoDiaFormatadoEnd; }

                    // eventoDataFormatadaEnd = Number(eventoAnoFormatadoEnd + eventoMesFormatadoEnd + eventoDiaFormatadoEnd);

                    // var exibirComunicadoUmaVez = null;
                    // if(sessionStorage.getItem('exibirComunicadoUmaVez') == null){
                    //     this.exibirComunicadoUmaVez = "true";
                    //     sessionStorage.setItem('exibirComunicadoUmaVez', "true");
                    //     exibirComunicadoUmaVez = "true"
                        
                    // }
                    // else{
                    //     this.exibirComunicadoUmaVez = sessionStorage.getItem('exibirComunicadoUmaVez');
                    //     exibirComunicadoUmaVez = sessionStorage.getItem('exibirComunicadoUmaVez');
                    // }
                    // Verifica se a data atual está dentro da data de publicação do comunicado
                    if(Number(currentDate) >= eventoDataFormatadaStart && Number(currentDate) <= Number(customObj.dateEnd.replace(/-/g, '')) && customObj.preview == false){
                        //alert("entrou no if");
                        this.alertaEvento = true;
                    }

                });
            }).catch((error) => {
                this.alertaEvento = false;
                console.log("Não possui eventos para exibir");
                console.log(error);
            });

        },
        fnModalEvento(){
            var that = this;
            // timestamp
            var now = new Date();
            var year = "" + now.getFullYear();
            var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
            var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
            //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
            var currentDate = year + month + day;
            

            //Verifica quando deve exibir o evento
            db.collection("eventos")//.orderBy("customtimestamp","desc")
            .where("escolaID", "==", userProperties.escolaID)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach(doc => {
                    // doc.data() is never undefined for query doc snapshots
                    //console.log(doc.id, " => ", doc.data());
                    
                    let customObj = doc.data()

                    var exibirEventoUmaVez = null;
                    if(sessionStorage.getItem('exibirEventoUmaVez') == null){
                        this.exibirEventoUmaVez = "true";
                        sessionStorage.setItem('exibirEventoUmaVez', "true");
                        exibirEventoUmaVez = "true"
                        
                    }
                    else{
                        this.exibirEventoUmaVez = sessionStorage.getItem('exibirEventoUmaVez');
                        exibirEventoUmaVez = sessionStorage.getItem('exibirEventoUmaVez');
                    }
                    // Verifica se a data atual está dentro da data de publicação do comunicado
                    if(Number(currentDate) >= Number(customObj.dateStart.replace(/-/g, '')) && Number(currentDate) <= Number(customObj.dateEnd.replace(/-/g, '')) && exibirEventoUmaVez == "true"){
                        this.itemsEventos = [];
                        this.exibirDialogEvento = true;
                        var storageRef = firebase.storage().ref();
                        var tangRef = storageRef.child('eventos/'+customObj.slug+'.'+customObj.extensao);

                        tangRef.getDownloadURL().then(urlImgFB =>                             {
                                // Once we have the download URL, we set it to our img element
                                //console.log(urlImgFB);
                                this.itemsEventos.push({"titulo": customObj.titulo, "descricao": customObj.descricao, "push": customObj.push, "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "exibicaoName": customObj.exibicaoName, "slug": customObj.slug, "extensao": customObj.extensao, "imgEvento": urlImgFB});
                                this.loading = false
                                this.exibirDialogEvento = true;

                                }).catch(error => {
                                    // If anything goes wrong while getting the download URL, log the error,
                                    that.itemsEventos.push({"titulo": customObj.titulo, "descricao": customObj.descricao, "push": customObj.push, "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "exibicaoName": customObj.exibicaoName, "slug": customObj.slug, "extensao": customObj.extensao});
                                    that.loading = false
                                });
                    }
                    else{
                        this.exibirDialogEvento = false;
                    }

                });
            }).catch((error) => {
                this.exibirDialogEvento = false;
                console.log("Não possui evento para exibir");
                console.log(error);
            });

        },
        comunicados(){
            // timestamp
            var now = new Date();
            var year = "" + now.getFullYear();
            var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
            var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
            //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
            var currentDate = year + month + day;
            

            //Verifica como e quando deve exibir o comunicado
            db.collection("comunicados")//.orderBy("customtimestamp","desc")
            .where("escolaID", "==", userProperties.escolaID)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach(doc => {
                    // doc.data() is never undefined for query doc snapshots
                    //console.log(doc.id, " => ", doc.data());
                    
                    let customObj = doc.data()

                    var exibirComunicadoUmaVez = null;
                    if(sessionStorage.getItem('exibirComunicadoUmaVez') == null){
                        this.exibirComunicadoUmaVez = "true";
                        sessionStorage.setItem('exibirComunicadoUmaVez', "true");
                        exibirComunicadoUmaVez = "true"
                        
                    }
                    else{
                        this.exibirComunicadoUmaVez = sessionStorage.getItem('exibirComunicadoUmaVez');
                        exibirComunicadoUmaVez = sessionStorage.getItem('exibirComunicadoUmaVez');
                    }
                    // Verifica se a data atual está dentro da data de publicação do comunicado
                    if(Number(currentDate) >= Number(customObj.dateStart.replace(/-/g, '')) && Number(currentDate) <= Number(customObj.dateEnd.replace(/-/g, '')) && exibirComunicadoUmaVez == "true"){
                        this.itemsComunicados = [];
                        this.dialogComunicado = true;
                        var storageRef = firebase.storage().ref();
                        var tangRef = storageRef.child('comunicados/'+customObj.slug+'.'+customObj.extensao);

                        tangRef.getDownloadURL().then(urlImgFB =>                             {
                                // Once we have the download URL, we set it to our img element
                                //console.log(urlImgFB);
                                this.itemsComunicados.push({"texto": customObj.texto, "push": customObj.push, "preview": customObj.preview, "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "exibicaoName": customObj.exibicaoName, "slug": customObj.slug, "extensao": customObj.extensao, "imgComunicado": urlImgFB});
                                this.loading = false
                                this.dialogComunicado = true;

                                }).catch(function(error) {
                                    // If anything goes wrong while getting the download URL, log the error,

                                    this.itemsComunicados.push({"texto": customObj.texto, "push": customObj.push, "preview": customObj.preview, "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "exibicaoName": customObj.exibicaoName, "slug": customObj.slug, "extensao": customObj.extensao});
                                    this.loading = false
                                });
                    }
                    else{
                        this.dialogComunicado = false;
                    }

                });
            }).catch((error) => {
                this.dialogComunicado = false;
                console.log("Não possui comunicados para exibir");
                console.log(error);
            });
        },
        enquete(){
            // timestamp
            var now = new Date();
            var year = "" + now.getFullYear();
            var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
            var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
            //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
            var currentDate = year + month + day;
            

            //Verifica como e quando deve exibir o comunicado
            db.collection("enquete")//.orderBy("customtimestamp","desc")
            .where("escolaID", "==", userProperties.escolaID)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach(doc => {
                    // doc.data() is never undefined for query doc snapshots
                    //console.log(doc.id, " => ", doc.data());
                    let customObj = doc.data()

                    var exibirEnqueteUmaVez = null;
                    if(sessionStorage.getItem('exibirEnqueteUmaVez') == null){
                        this.exibirEnqueteUmaVez = "true";
                        sessionStorage.setItem('exibirEnqueteUmaVez', "true");
                        exibirEnqueteUmaVez = "true"
                        
                    }
                    else{
                        this.exibirEnqueteUmaVez = sessionStorage.getItem('exibirEnqueteUmaVez');
                        exibirEnqueteUmaVez = sessionStorage.getItem('exibirEnqueteUmaVez');
                    }
                    // Verifica se a data atual está dentro da data de publicação do comunicado
                    if(Number(currentDate) >= Number(customObj.dateStart.replace(/-/g, '')) && Number(currentDate) <= Number(customObj.dateEnd.replace(/-/g, '')) && exibirEnqueteUmaVez == "true"){
                        this.itemsEnquetes = [];
                        // this.dialogEnquete = true;
                        this.slugEnquete = customObj.slug;
                        this.docIdEnquete = doc.id;
                        // If anything goes wrong while getting the download URL, log the error,

                        this.itemsEnquetes.push({"pergunta": customObj.pergunta, "push": customObj.push, "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "slug": customObj.slug, "respostas": customObj.respostas});

                        // Valida se usuario logado ja votou
                        var quantidadeItens = null;
                        db.collection("enquete").doc(doc.id).collection("votos")
                        .where("slugAutor", "==", userProperties.slug)
                        .get()
                        .then((querySnapshot) => {
                            quantidadeItens = querySnapshot.size;
                            if(quantidadeItens > 0){
                                this.loading = false
                                this.dialogEnquete = false;
                            }
                            if(quantidadeItens <= 0){
                                this.loading = false
                                this.dialogEnquete = true;
                            }
                        })

                        
                    }

                });
            }).catch((error) => {
                this.dialogEnquete = false;
                console.log("Não possui enquete para exibir");
                console.log(error);
            });
        },
        alertaMedicacao(){
            // timestamp
            var now = new Date();
            var year = "" + now.getFullYear();
            var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
            var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
            //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
            var currentDate = year + month + day;

            

            //Verifica como e quando deve exibir o comunicado
            db.collection("medicacao")//.limit(1)//.orderBy("customtimestamp","desc")
            .where("escolaID", "==", userProperties.escolaID)
            .get()
            .then((querySnapshot) => {
                this.exibirAlertaMedicacao = false;
                querySnapshot.forEach(doc => {
                    // doc.data() is never undefined for query doc snapshots
                    //console.log(doc.id, " => ", doc.data());
                    
                    let customObj = doc.data()
                    
                    // Verifica se a data atual está dentro da data de publicação do comunicado
                    if(Number(currentDate) >= Number(customObj.dateStart.replace(/-/g, '')) && Number(currentDate) <= Number(customObj.dateEnd.replace(/-/g, ''))){
                                //this.itemsMedicacao.push({"texto": customObj.texto, "push": customObj.push, "preview": customObj.preview, "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "exibicaoName": customObj.exibicaoName, "slug": customObj.slug, "extensao": customObj.extensao, "imgComunicado": urlImgFB});
                                globalProperties.exibirAlertaMedicacao = true;                                
                    }

                });
            }).catch((error) => {
                this.exibirAlertaMedicacao = false;
                console.log("Não possui alertas de medicação para exibir");
                console.log(error);
            });
        },
        fecharComunicado(){
            this.dialogComunicado = false;
            this.exibirComunicadoUmaVez = false;
            sessionStorage.setItem('exibirComunicadoUmaVez', false);
        },
        fecharEnquete(){
            this.dialogEnquete = false;
            this.exibirEnqueteUmaVez = false;
            sessionStorage.setItem('exibirEnqueteUmaVez', false);
        },
        votarEnquete(){
            if(this.radios == null){
                alert("Selecione uma resposta!")
            }
            else{
                var slugVoto = this.generateUUID();

                db.collection("enquete").where("slug", "==", this.slugEnquete)
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach(doc => {
                        console.log(doc.id, " => ", doc.data());
                        // Build doc ref from doc.id
                        db.collection("enquete").doc(doc.id).collection('votos').add({
                            "slug":slugVoto, 
                            "slugAutor":userProperties.slug,
                            "escolaID":userProperties.escolaID,
                            "resposta": this.radios
                            //texto: "testeabc" 
                            
                        }).then(docRef => {
                            //this.$router.push(`/${slug}/success`)
                            
                            alert("Voto realizado com sucesso!");
                            this.loading = false
                            this.dialogEnquete = false;

                            // Log do sistema
                            // timestamp
                            var now = new Date();
                            var year = "" + now.getFullYear();
                            var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                            var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                            var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                            var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                            var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                            //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                            var customtimestamp = year + month + day + hour + minute + second

                            db.collection('log_' + userProperties.escolaID).add({
                                    escolaID: userProperties.escolaID,
                                    slugAutor: userProperties.slug,
                                    perfil: userProperties.perfil,
                                    
                                    slug: that.slug,
                                    customtimestamp: customtimestamp,
                                    dia: day,
                                    mes: month,
                                    ano: year,
                                    acao: "votar",
                                    categoria: "enquete",
                                    pontos: 7
                                    
                                })
                                .then(docRef => {
                                    console.log('Document written with ID: ', docRef.id);

                                    
                                })
                                .catch(function (error) {
                                    console.log('Error adding document: ', error);
                                    console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                                })
                                
                        })
                        .catch(function (error) {
                            console.log('Error adding document: ', error);
                        })

                    });
                })
            }
            
            // this.dialogEnquete = false;
            // this.exibirEnqueteUmaVez = false;
            // sessionStorage.setItem('exibirEnqueteUmaVez', false);
        },
        fecharEvento(){
            this.exibirEventoUmaVez = false;
            sessionStorage.setItem('exibirEventoUmaVez', false);
        },        
        getUsersData(){
            db.collection("usuarios").where("escolaID", "==", userProperties.escolaID)
            .get()
            .then((querySnapshot) => {
                console.log("Popula userData");
                var that = this;

                var objUsers = [];
                //var quantidadeItens = querySnapshot.size
                querySnapshot.forEach(doc => {
                   
                    // doc.data() is never undefined for query doc snapshots
                    console.log(doc.id, " => ", doc.data());               
                    let customObj = doc.data()
                    objUsers.push(doc.data());

                    try{
                        userProperties.turmas.forEach(function(item, index){
                            //alert("for1"+item);
                            customObj.turmas.forEach(function(item2, index2){
                                //alert("for2"+item2);
                                if(item == item2){
                                    that.filtroPorTurma.push(customObj.slug);
                                }
                            });
                        });
                    }
                    catch(err){
                        console.log(err)
                    }
                    
                });
                usersData.usuarios = objUsers;
                // console.log(objUsers);
                
                //console.log("usuarios por turma");
                //console.log(that.filtroPorTurma);
                usersData.slugUsuariosPorTurma = that.filtroPorTurma;
                
            })
            .catch(function (error) {
                console.log("Erro ao buscar dados dos usuários.");
                that.updateEscolaID();
                //setTimeout(function(){ that.setUSerproperties(); }, 3000);

                
            });
        },
        controlePaginacao(){
            setTimeout(() => { 
                this.paginacaoUmaVez == 0;                
                                
            }, 5000);
        },
        carregaDados(){
            setTimeout(() => { 
                if(userProperties.loaded != true){
                    location.reload();
                }
                                
            }, 13000);
            

            this.loading = true
            this.setUSerproperties();
            
            // Google Analytics Tag
            gtag('set', {'user_id': userProperties.slug}); // Defina o ID de usuário usando o user_id conectado.

            // Google Analytics Tag
            gtag('config', 'UA-151323970-1', {
                'custom_map': {'dimension6': 'Perfil'}
            });
            gtag('event', 'define_perfil', {'Perfil': userProperties.perfil});

            // Google Analytics Tag
            gtag('config', 'UA-151323970-1', {
                'custom_map': {'dimension1': 'UserID'}
            });
            gtag('event', 'define_id', {'UserID': userProperties.slug});

            // Google Analytics Tag
            gtag('config', 'GA_MEASUREMENT_ID', {
                'user_id': userProperties.slug
            });
            

            // gtag('event', '<action>', {
            //     'event_category': '<category>',
            //     'event_label': '<label>',
            //     'value': '<value>'
            // });

            this.fnAlertaEvento();

            this.items = [];
            this.todosItems = [];
        
            var urlImgFB = "";
            var urlImg = "";

            var that = this;

            function ordenarPorTimestamp(a, b){
                //return a.customtimestamp - b.customtimestamp; // crescente
                return b.customtimestamp - a.customtimestamp; // decrescente
            }

            
            // Listagem dos posts
            console.log("escolaID");
            console.log(userProperties.escolaID);
            
            db.collection("posts_" + userProperties.escolaID).limit(300).orderBy("customtimestamp","desc") //asc or desc
                .get()
                .then((querySnapshot) => {
                    
                    querySnapshot.forEach(doc => {
                        // doc.data() is never undefined for query doc snapshots
                        //console.log(doc.id, " => ", doc.data());                    
                        let customObj = doc.data()

                        // recupera imagem do firebase storage
                        var storageRef = firebase.storage().ref();
                        var tangRef = storageRef.child('postagens/'+customObj.slug+'.'+customObj.extensao);

                        // First we sign in the user anonymously
                        //firebase.auth().signInAnonymously().then((result) => {
                        // Once the sign in completed, we get the download URL of the image
                        
                        tangRef.getDownloadURL().then(urlImgFB =>                             {
                            // Once we have the download URL, we set it to our img element
                            // Build doc ref from doc.id
                            var quantidadeCurtidas = null;
                            var statusCurtida = false
                            db.collection("posts_" + userProperties.escolaID).doc(doc.id).collection("curtidas")
                            .get()
                            .then((querySnapshot) => {
                                quantidadeCurtidas = querySnapshot.size;
                                querySnapshot.forEach(doc => {
                                    // doc.data() is never undefined for query doc snapshots
                                    //console.log(doc.id, " => ", doc.data());                    
                                    let customObjCurtidas = doc.data()
                                    if(customObjCurtidas.slugAutor == userProperties.slug){
                                        statusCurtida = true;
                                    }
                                })
                            })

                            // Build doc ref from doc.id
                            var quantidadeItens = null;
                            db.collection("posts_" + userProperties.escolaID).doc(doc.id).collection("comentarios")
                            .get()
                            .then((querySnapshot) => {
                                quantidadeItens = querySnapshot.size;
                                if(customObj.video != undefined && customObj.video != null){
                                    var videoID = "";
                                    if(customObj.video.indexOf("youtu.be/") >= 0){
                                        videoID = customObj.video.split(".be/")[1];
                                        if(videoID.indexOf("&feature") >= 0){
                                            videoID = videoID.split("&feature")[0];    
                                        }
                                    }
                                    else{
                                        videoID = customObj.video.split("?v=")[1];
                                        if(videoID.indexOf("&feature") >= 0){
                                            videoID = videoID.split("&feature")[0];    
                                        }
                                    }
                                }
                                
                                if(customObj.video != null && customObj.video != ""){
                                    this.todosItems.push({"quantidadeCurtidas": quantidadeCurtidas, "statusCurtida": statusCurtida, "quantidadeComentarios": quantidadeItens, "nome": customObj.nome, "email": customObj.email, "slug": customObj.slug, "slugAutor": customObj.slugAutor, "extensao": customObj.extensao, "imagemPost": urlImgFB, "imagemPerfil": customObj.imagemPerfil, "texto": customObj.texto, "textoLink": customObj.textoLink, "tipo": customObj.tipo, "video": "https://www.youtube.com/embed/"+videoID, "link": customObj.link, "customtimestamp": customObj.customtimestamp, "ano": customObj.customtimestamp.substring(0,4), "mes": customObj.customtimestamp.substring(4,6), "dia": customObj.customtimestamp.substring(6,8), "hora": customObj.customtimestamp.substring(8,10), "minuto": customObj.customtimestamp.substring(10,12) });
                                }
                                else{
                                    this.todosItems.push({"quantidadeCurtidas": quantidadeCurtidas, "statusCurtida": statusCurtida, "quantidadeComentarios": quantidadeItens, "nome": customObj.nome, "email": customObj.email, "slug": customObj.slug, "slugAutor": customObj.slugAutor, "extensao": customObj.extensao, "imagemPost": urlImgFB, "imagemPerfil": customObj.imagemPerfil, "texto": customObj.texto, "textoLink": customObj.textoLink, "tipo": customObj.tipo, "link": customObj.link, "customtimestamp": customObj.customtimestamp, "ano": customObj.customtimestamp.substring(0,4), "mes": customObj.customtimestamp.substring(4,6), "dia": customObj.customtimestamp.substring(6,8), "hora": customObj.customtimestamp.substring(8,10), "minuto": customObj.customtimestamp.substring(10,12) });
                                }
                                
                                this.slug = customObj.slug;
                                this.loading = false;

                                // Ordenacao numerica
                                that.todosItems.sort(ordenarPorTimestamp);
                                cache.homeObj = that.todosItems;

                            })
                                    
                        }).catch(function(error) {
                            // If anything goes wrong while getting the download URL, log the error,
                            var quantidadeCurtidas = null;
                            var statusCurtida = false
                            db.collection("posts_" + userProperties.escolaID).doc(doc.id).collection("curtidas")
                            .get()
                            .then((querySnapshot) => {
                                quantidadeCurtidas = querySnapshot.size;
                                querySnapshot.forEach(doc => {
                                    // doc.data() is never undefined for query doc snapshots
                                    //console.log(doc.id, " => ", doc.data());                    
                                    let customObjCurtidas = doc.data()
                                    if(customObjCurtidas.slugAutor == userProperties.slug){
                                        statusCurtida = true;
                                    }
                                })
                            })

                            // Build doc ref from doc.id
                            var quantidadeItens = null;
                            db.collection("posts_" + userProperties.escolaID).doc(doc.id).collection("comentarios")
                            .get()
                            .then((querySnapshot) => {
                                quantidadeItens = querySnapshot.size;

                                if(customObj.video != undefined && customObj.video != null){
                                    var videoID = "";
                                    if(customObj.video.indexOf("youtu.be/") >= 0){
                                        videoID = customObj.video.split("be/")[1];
                                        if(videoID.indexOf("&feature") >= 0){
                                            videoID = videoID.split("&feature")[0];    
                                        }
                                    }
                                    else{
                                        videoID = customObj.video.split("?v=")[1];
                                        if(videoID.indexOf("&feature") >= 0){
                                            videoID = videoID.split("&feature")[0];    
                                        }
                                    }
                                }
                                

                                that.todosItems.push({"quantidadeCurtidas": quantidadeCurtidas, "statusCurtida": statusCurtida, "quantidadeComentarios": quantidadeItens, "nome": customObj.nome, "email": customObj.email, "slug": customObj.slug, "slugAutor": customObj.slugAutor, "extensao": customObj.extensao, "texto": customObj.texto, "textoLink": customObj.textoLink, "tipo": customObj.tipo, "video": "https://www.youtube.com/embed/"+videoID, "link": customObj.link, "customtimestamp": customObj.customtimestamp, "ano": customObj.customtimestamp.substring(0,4), "mes": customObj.customtimestamp.substring(4,6), "dia": customObj.customtimestamp.substring(6,8), "hora": customObj.customtimestamp.substring(8,10), "minuto": customObj.customtimestamp.substring(10,12) });
                                cache.homeObj = that.todosItems;
                                cache.home = true;
                                that.slug = customObj.slug;
                                that.loading = false
                                //console.error(error);

                            })

                            
                        });
                            
                        
                    });
                    // Ordenacao numerica
                    that.todosItems.sort(ordenarPorTimestamp);
                    cache.homeObj = that.todosItems;
                    
                    // Paginacao dinamica - ao chegar no fim da rolagem
                    
                        setTimeout(() => { 
                            
                            var exibir = that.todosItems;
                            //that.items = that.todosItems
                            exibir.forEach((item, index) => {
                                if(index <= that.paginacao){
                                    that.items.push(item);
                                }
                            });

                            // console.log(document.documentElement.offsetHeight - window.innerHeight);
                            // console.log("------------------------")
                            // console.log($(window).scrollTop());
                            $(window).scroll(() => {
                                that.debug1 = document.documentElement.offsetHeight - window.innerHeight;
                                that.debug2 = $(window).scrollTop();
                                // console.log(document.documentElement.offsetHeight - window.innerHeight);
                                // console.log("------------------------")
                                // console.log($(window).scrollTop());
                                //if(document.documentElement.offsetHeight - window.innerHeight == $(window).scrollTop() && that.loading == false) { validação do loading
                                if(Math.round($(window).scrollTop()) == document.documentElement.offsetHeight - window.innerHeight) { // Valida se chegou no final da rolagem
                                    // ajax call get data from server and append to the div
                                    //alert("Carrega mais!");
                                    if(that.paginacaoUmaVez == 0){ // If para contornar erro de chamar varias vezes essa funcao ao chegar no fim da rolagem
                                        that.paginacaoUmaVez == 1;
                                        that.controlePaginacao();
                                        that.items = [];
                                        var exibir = that.todosItems;
                                        exibir.forEach((item, index) => {
                                            if(index <= Number(that.paginacao) + 10){ // paginacao - adiciona mais 10 itens toda vez que chegar no final da rolagem
                                                that.items.push(item);
                                            }
                                                
                                        });
                                        that.paginacao = that.paginacao + 10;
                                                
                                    }
                                    //that.loading = true
                                }
                            });
                        }, 3000);                        
                    
                }).catch((error) => {
                        this.loading = false;
                        this.todosItems = []
                        console.log("zera o objeto todosItems")
                        this.carregaDados();
                });
            // Ordenacao numerica
            that.todosItems.sort(ordenarPorTimestamp);
            cache.homeObj = that.todosItems;
            cache.home = true;

            db.collection("usuarios")
                        .where("escolaID", "==", userProperties.escolaID)
                        .get()
                        .then((querySnapshot) => {
                            console.log(querySnapshot);
                            this.qtdUsuarios = querySnapshot.size
                        })
                        .catch(function (error) {
                            console.log("Erro ao obter a quantidade de usuários.");
                        });

            db.collection("usuarios")
                        .where("escolaID", "==", userProperties.escolaID).where("perfil", "==", 7)
                        .get()
                        .then((querySnapshot) => {
                            console.log(querySnapshot);
                            this.qtdAlunos = querySnapshot.size
                        })
                        .catch(function (error) {
                            console.log("Erro ao obter a quantidade de usuários.");
                        });
            //alert(propertiesLoaded);
            // Obtém os dados da sessionStorage
            

            
            
            
        },
        setUserImage(){
            if(userProperties.loaded == false && userProperties.perfil == "2"){
                var storageRef = firebase.storage().ref();
                var tangRef = storageRef.child('profile/'+userProperties.slug+'.'+userProperties.extensao);

                // First we sign in the user anonymously
                //firebase.auth().signInAnonymously().then((result) => {
                // Once the sign in completed, we get the download URL of the image
            
                tangRef.getDownloadURL().then(urlImgFB =>                             {
                // Once we have the download URL, we set it to our img element
                console.log(urlImgFB);
                //this.urlImg = urlImgFB;
                userProperties.imagem = urlImgFB;

                }).catch(function(error) {
                    // If anything goes wrong while getting the download URL, log the error
                    console.error(error);
                });
            }
            
        },
        deletarComentario(slugComentario){
            this.slugComentario = slugComentario;
            this.dialogDeletarComentarioConfirmacao = true;
        },
        deletarComentarioConfirmacao(){
            this.loading = true
            this.dialogDeletarComentarioConfirmacao = false;
            db.collection("posts_" + userProperties.escolaID).where("slug", "==", this.slugPost)
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach(doc => {
                        console.log(doc.id, " => ", doc.data());
                        // Build doc ref from doc.id
                        db.collection("posts_" + userProperties.escolaID).doc(doc.id).collection("comentarios").where("slug", "==", this.slugComentario)
                        .get()
                        .then((querySnapshot) => {
                            querySnapshot.forEach(doc2 => {
                                //var quantidadeItens = querySnapshot.size;
                                doc2.ref.delete().then(() => {
                                    //this.dialog = true
                                    this.dialogComentarios = false;
                                    this.comentarios(this.slugPost);
                                    this.loading = false
                                //console.log("Document successfully deleted!");
                                }).catch(function(error) {
                                    alert("Erro ao deletar comentário!");
                                    this.loading = false
                                //console.error("Error removing document: ", error);
                                });
                            })
                            
                        })
                        

                    });

                })

        },
        updateEscolaID(){
            if(userProperties.escolaID == 0){ //Esses usuaios ganham seu ID no primeiro login
                
                db.collection('usuarios').where("slug", "==", userProperties.slug)
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach(doc => {
                        console.log(doc.id, " => ", doc.data());
                        // Build doc ref from doc.id
                        db.collection('usuarios').doc(doc.id).update({                        
                            escolaID: doc.id,
                            tokenFMC: this.tokenFMC
                        }).then(docRef => {
                           userProperties.escolaID = doc.id;
                           this.setUserImage();
                        })
                        .catch(function (error) {
                            this.loading = false
                            console.log('Error adding document: ', error);
                            console.log("Erro na atualização dos dados. Tente novamente mais tarde!")
                        })
                        this.loading = false,
                        this.dialog = true

                    });
                })

            }

            else if(userProperties.escolaID != "" && userProperties.escolaID != null && userProperties.escolaID != undefined && $.cookie("updateTokenFCM") == null && this.tokenFMC != null){ //
                // set cookie
                $.cookie("updateTokenFCM", "querySnapshot.size", { expires: 1 });// apenas a cada 1 dias atualiza do token FCM
                
                db.collection('usuarios').where("slug", "==", userProperties.slug)
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach(doc => {
                        console.log(doc.id, " => ", doc.data());
                        // Build doc ref from doc.id
                        db.collection('usuarios').doc(doc.id).update({                        
                            //escolaID: this.escolaID,
                            tokenFMC: this.tokenFMC
                        }).then(docRef => {
                            
                           userProperties.escolaID = this.escolaID;
                            
                        })
                        .catch(function (error) {
                            this.loading = false
                            console.log('Error adding document: ', error);
                            console.log("Erro na atualização dos dados. Tente novamente mais tarde!")
                        })
                        this.loading = false,
                        this.dialog = true

                    });
                })





            }

        },
        editarItem(slug){
            this.$router.push(`/Editar-Post/?slug=`+slug)
        },
        deletarItem(slug){
            this.slug = slug;
            this.dialogDeleteConfirm = true;
        },
        goToEvento(){
            this.$router.push(`/eventos-listagem`)
        },
        fecharModalAniversario(){
            this.dialogAniversario = false;
            sessionStorage.setItem('modalAniversario', "visualizado");
        },
        deletarItemConfirm(){
            var slug = this.slug;
            this.loading = true
            db.collection("posts_" + userProperties.escolaID).where("slug", "==", slug)
            .get()
            .then(querySnapshot => {
                querySnapshot.forEach((doc) => {
                    doc.ref.delete().then(() => {
                    this.dialog = true
                    //console.log("Document successfully deleted!");
                    }).catch(function(error) {
                    //console.error("Error removing document: ", error);
                    });
                });
                this.loading = false;
                this.dialogDeleteConfirm = false;
                this.carregaDados();
                
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
                this.loading = false;
                this.dialogDeleteConfirm = false;
                alert("Error while trying to delete, please try again.");
            });
        },
    },
    data() {
        return {
            loadingPadrao: false,
            docIdEnquete:null,
            radios: null,
            debug1: null,
            debug2: null,
            img1: img1,
            img2: img2,
            img3: img3,
            imgLike1: imgLike1,
            imgLike2: imgLike2,
            lixeira: lixeira,
            icFecharLaranja: icFecharLaranja,
            qtdUsuarios: null,
            qtdAlunos: null,
            qtdTestemunhas: null,
            nome: null,
            slug: this.slug,
            slugUsuarioLogado: userProperties.slug,
            perfilUsuarioLogado: userProperties.perfil,
            extensao: this.extensao,
            escolaID: "0",
            items: [],
            todosItems: [],
            itemsComunicados: [],
            itemsEnquetes: [],
            itemsComentarios: [],
            itemsCurtidas: [],
            itemsEventos: [],
            dialogDeleteConfirm: false,
            dialogAniversario: false,
            dialogComentarios: false,
            dialogComunicado: false,
            dialogEnquete: false,
            exibirComunicadoUmaVez: true,
            exibirEventoUmaVez: true,
            exibirEnqueteUmaVez: true,
            modalMessage: 'Item excluído com sucesso!',
            tokenFMC: null,
            filtroPorTurma: [],
            slugPost: null,
            textoComentario: null,
            alertaEvento: false,
            msgEventoAlerta: "Temos eventos se aproximando. Clique aqui para ver os detalhes!",
            dialogDeletarComentarioConfirmacao: false,
            slugComentario: null,
            exibirDialogEvento: null,
            paginacaoUmaVez: 0, // variavel para contornar bug de estar chamando a funcao varias vezes ao chegar no final da pagina
            paginacao: 9 // indice começa no zero, ou seja se deixar o valor 1 exibe 2 itens
        }
    },
    created() {

        //script para ajustar o tamanho da tela no DESKTOP
        var isMobile = false; //initiate as false
        // device detection
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
            isMobile = true;
        }
        if(isMobile == false){
            window.resizeTo(400, 700)
        }

        // Ajuste na primeira abertura do aplicativo que não carrega
        if(sessionStorage.getItem('sessaoAtiva') == null){ // Get sessionStorage
            sessionStorage.setItem('sessaoAtiva', "true"); // Set sessionStorage
            setTimeout(function(){ 
                location.reload();    
            }, 1000);
        }
        
        // Google Analytics - Pageview
        this.$ga.page({
            page: '/',
            title: 'Home page',
            location: window.location.href
        })

        // Popula o numero de quantidade de notificações
        db.collection('notificacoes').where("destinatario", "==", userProperties.slug)
        .get()
        .then((querySnapshot) => {
            // set cookie
            $.cookie("qtdNotificacoes", querySnapshot.size, { expires: 60 });
            
            
        });


        var that = this;

        // Exibição modal aniversario - Exibe se dia/mes atual for igual a dia/mes da data de nascimento
        var now = new Date();
        var year = "" + now.getFullYear();
        var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
        var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
        //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
        var currentDate = day + month;
        
        var modalAniversarioVisualizada = sessionStorage.getItem('modalAniversario');
        
        var myInterval = setInterval(function(){
            if(userProperties.escolaID != null){
                if(userProperties.dataNascimento != null){
                    var aniver = userProperties.dataNascimento.substring(0,2) + userProperties.dataNascimento.substring(3,5);
                    if(aniver == currentDate && modalAniversarioVisualizada != "visualizado"){
                        that.dialogAniversario = true;
                    }
                }
                
                
                clearInterval(myInterval);
            }
                     
        },2000);

        
        

        // Obtém os dados da sessionStorage
        this.tokenFMC = sessionStorage.getItem('tokenFMC');

        this.loading = true;
        console.log("cache.home");
        console.log(cache.home);
        if(userProperties.loaded == true){
            
            if(cache.home == false){
                cache.homeObj = [];
                console.log("dados do banco");
                    this.carregaDados();
                //this.carregaDados();
            }
            else{
                // pega dados do cache                
                this.loading = false;
                this.todosItems = cache.homeObj;
                console.log("dados do cache");
                setTimeout(() => { 
                                
                    var exibir = this.todosItems;
                    //that.items = that.todosItems
                    exibir.forEach((item, index) => {
                        if(index <= that.paginacao){
                            that.items.push(item);
                        }
                    });
                    // ######## Exibir paginado os dados do cache
                    // console.log(document.documentElement.offsetHeight - window.innerHeight);
                    // console.log("------------------------")
                    // console.log($(window).scrollTop());
                    $(window).scroll(() => {
                        that.debug1 = document.documentElement.offsetHeight - window.innerHeight;
                        that.debug2 = $(window).scrollTop();
                        // console.log(document.documentElement.offsetHeight - window.innerHeight);
                        // console.log("------------------------")
                        // console.log($(window).scrollTop());
                        //if(document.documentElement.offsetHeight - window.innerHeight == $(window).scrollTop() && that.loading == false) { validação do loading
                        if(Math.round($(window).scrollTop()) == document.documentElement.offsetHeight - window.innerHeight) { // Valida se chegou no final da rolagem
                            // ajax call get data from server and append to the div
                            //alert("Carrega mais!");
                            if(that.paginacaoUmaVez == 0){ // If para contornar erro de chamar varias vezes essa funcao ao chegar no fim da rolagem
                                that.paginacaoUmaVez == 1;
                                that.controlePaginacao();
                                that.items = [];
                                var exibir = that.todosItems;
                                exibir.forEach((item, index) => {
                                    if(index <= Number(that.paginacao) + 10){ // paginacao - adiciona mais 10 itens toda vez que chegar no final da rolagem
                                        that.items.push(item);
                                    }
                                        
                                });
                                that.paginacao = that.paginacao + 10;
                                        
                            }
                            //that.loading = true
                        }
                    });
                    this.loading = false
                }, 100);
            }
        }
        else{
            setTimeout(function(){
                console.log("dados do banco");
                that.carregaDados(); 
            }, 2000);            
        }

        var myInterval2 = setInterval(function(){
            if(userProperties.escolaID != null){
                that.comunicados(); // Só vai chamar esse metodo uma vez por sessão
                
                clearInterval(myInterval2);
            }
                     
        },2000);

        var myInterval5 = setInterval(function(){
            if(userProperties.escolaID != null){
                that.fnModalEvento(); // Só vai chamar esse metodo uma vez por sessão
                
                clearInterval(myInterval5);
            }
                     
        },2000);

        var myInterval9 = setInterval(function(){
            if(userProperties.escolaID != null){
                that.enquete(); // Só vai chamar esse metodo uma vez por sessão
                
                clearInterval(myInterval9);
            }
                     
        },2000);

        // metodo que adiciona curtidas
        var myInterval8 = setInterval(function(){
            if($(".like").html() != undefined){
                $(".like").click(function(){

                    // Google Analytics - Events
                    gtag('event', 'clicou', {
                        'event_category': 'homepage',
                        'event_label': 'curtir'//,
                        //'value': '<value>'
                    });

                    var curtidas = $(this).find("span").text();
                    curtidas = Number(curtidas) + 1;
                    if($(this).find(".curtir").is(":visible")){
                        $(this).find("span").text(curtidas);
                        
                        var slugCurtida = that.generateUUID();

                        
                   



                        db.collection("posts_" + userProperties.escolaID).where("slug", "==", $(this).attr("data-slug"))
                        .get()
                        .then((querySnapshot) => {
                            querySnapshot.forEach(doc => {
                                console.log(doc.id, " => ", doc.data());
                                // Build doc ref from doc.id
                                db.collection("posts_" + userProperties.escolaID).doc(doc.id).collection('curtidas').add({
                                    "slug":slugCurtida, 
                                    "slugAutor":userProperties.slug
                                    //texto: "testeabc" 
                                    
                                }).then(docRef => {
                                    //this.$router.push(`/${slug}/success`)
                                    
                                    console.log('Item curtido com sucesso');
                                    cache.home = false;
                                    carregaDadosUmaVez = false;

                                    // Log do sistema
                                    // timestamp
                                    var now = new Date();
                                    var year = "" + now.getFullYear();
                                    var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                                    var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                                    var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                                    var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                                    var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                                    //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                                    var customtimestamp = year + month + day + hour + minute + second

                                    db.collection('log_' + userProperties.escolaID).add({
                                            escolaID: userProperties.escolaID,
                                            slugAutor: userProperties.slug,
                                            perfil: userProperties.perfil,
                                            
                                            //slug: that.slug,
                                            customtimestamp: customtimestamp,
                                            dia: day,
                                            mes: month,
                                            ano: year,
                                            acao: "curtir",
                                            categoria: "postagens",
                                            pontos: 2
                                            
                                        })
                                        .then(docRef => {
                                            console.log('Document written with ID: ', docRef.id);

                                            
                                        })
                                        .catch(function (error) {
                                            console.log('Error adding document: ', error);
                                            console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                                        })
                                        
                                })
                                .catch(function (error) {
                                    console.log('Error adding document: ', error);
                                })

                            });
                        })


                    }
                    $(this).find(".curtir").hide();
                    $(this).find(".curtido").show();

                })
                //clearInterval(myInterval8);
            }
                     
        },3000);

        
        
        // Apenas para professores / administrativo-professores - Verifica se tem lembrete de medicação no dia atual
        setTimeout(function(){
            if(userProperties.perfil == 4 || userProperties.perfil == 5)
                that.alertaMedicacao();
        }, 8000);

        var myInterval3 = setInterval(function(){
            if(userProperties.perfil == 4 || userProperties.perfil == 5){
                that.alertaMedicacao();
                console.log("Re-valida a cada 3 horas se possui alerta de medicação");
            }
            //if(userProperties.nome != null)
                //clearInterval(myInterval3);     
        },30000000); // re-verifica a cada 3 horas

        
        
    }
};




</script>

<style scoped>
span.headline{
    font-size: 40px !important;
    display: block;
    text-align: center;
}

h3.headline{
}

.box{
    margin-top: 15px;
}

.body-content{
    width: 100%;
}

.loading{
        position: fixed;
        top:10%;
        /*left:24%;*/
        z-index: 2;
    }
    
    .loading .img1{width: 100%; height: auto;}
    .loading .img2{width: 300%; height: auto;}
    

    .deletar{
        position: absolute;
        min-width: auto;
        height: auto;
        padding: 1px 6px !important;
        right: 0;
        top: 0;
    }

    .release{
        background-color:beige;
        position:absolute;
        right: 12px;

    }

    .editar{
        background-color:beige;
        position:absolute;
        right: 112px;

    }

    .imagem{
        width: 100%;
        height: auto;
    }

    .instagram{
        position: absolute;
        left: 15px;
    }

    .body-content .headline{
        font-size: 16px !important;
        font-weight: bold;
        overflow: hidden;
        height: 28px;
    }

    .hide{
        display: none;
    }

    .v-card__text .v-input--selection-controls .v-input__control, .v-input__control{
        width: 100% !important;
    }

    .titulo-post{
        padding-top: 10px;
        padding-bottom: 5px;
        margin-left:16px;
    }

    .img-modal-comunicado, .img-modal-evento{
        width: 100% !important;
        height: auto;
    }

    .fecharComentario{
        float: right;
        color: red;
        font-size: 20px;
        margin: 6px 15px 0 0;
    }

    button.comentar{
        padding: 0 !important;
    }

    .alertaEvento{
        width: 96%;
        margin-top: 15px;
        padding-top: 0 !important;
    }

    a.fecharAviso{
        color: #000;
        position: absolute;
        right: 6px;
        top: 4px;
        font-size: 16px
    }

    .deletarComentario{
        float: right;
        color: #000;
        position: relative;
        top: -20px;
    }

    .like{
        position:absolute;
        right: 14px;
        color: #ff9800;
        font-size: 12px;
    }

    .like img{
        position: relative;
        top: 5px;
    }

    .like.true .curtido{
        display: inline;
    }
    .like.true .curtir{
        display: none;
    }

    .like.false .curtido{
        display: none;
    }
    .like.false .curtir{
        display: inline;
    }

    .alertaEvento div{
        color: #fff !important;
        font-size: 16px !important
    }

    .v-input--selection-controls{
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    @media screen and (max-width: 769px) {
        .v-input--selection-controls .v-input__control{
            width:100% !important;
        }
    }

    @media screen and (max-width: 569px) {
        .btClear{
            padding-top: 0 !important;
            position: relative;
            top:-15px;
            left:-5px;
        }
    }

    .fecharX{
        position: absolute;
        top:7px;
        right: 12px;
        color: #ff9800;
    }

    .loadingPadrao {
        position: fixed;
        top: 40%;
        left: 44%;
        z-index: 2;
        z-index: 9999;
    }

    .lixeira{
        margin-top: 3px;
    }

    .comentarios-modal .flex{
        background: silver;
        border-radius: 10px;
        margin: 1px 5px;
    }
    
</style>
